module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('h1', {
    staticClass: "chpTitle-break",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('a', {
    attrs: {
      "href": "#/QueenForADay13"
    }
  }, [_vm._v("Sleepwalking Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of Annie Sullivan")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yolanda")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Mothers")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queen for a Day")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("This Time Next Year")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route 94")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bike Path")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Boy Who Lived on a Desert Island")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sample Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "contentslist"
  }, [_c('span', {
    attrs: {
      "href": "#/QueenForADay23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Red Cart")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f493a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QueenForADay12.vue
// module id = 69
// module chunks = 0